// https://ant.design/docs/react/replace-moment
import dayjs from "dayjs";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";
import "antd/es/date-picker/style/index";

const DatePicker = generatePicker<dayjs.Dayjs>(dayjsGenerateConfig);

export default DatePicker;
